module.exports = __webpack_public_path__ + "37b164e18edd675691076ae1addf9857.pdf";